import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IConfirmResponse, IConfirmRequest } from "@interfaces/auth";
import useAppState from "../../contexts/state";
import { auth } from "@services/auth/auth-service";
import { handleApiError } from "@services/api";
import { LoaderCircle } from "lucide-react";
import toast from "react-hot-toast";
import { useQuery } from "@/utils/utils";
import { EmailOtpType } from "@supabase/supabase-js";

const Confirm = () => {
  document.title = "Verifying your details...";

  const query = useQuery();

  const navigate = useNavigate();

  const { setSession } = useAppState((state: any) => ({
    setSession: state.setSession,
  }));

  const confirm = async (data: IConfirmRequest) => {
    try {
      const response = await auth.confirm(data);
      const { user, session, type, next } = response.data as IConfirmResponse;
      if (user) {
        if (type === "signup") {
          toast.success("Email verified successfully");
        }
        setTimeout(() => {
          setSession(user, session);
          navigate(next || "/");
        }, 2000);
      }
    } catch (e) {
      console.log(handleApiError(e));
      if (handleApiError(e) === "Email link is invalid or has expired") {
        toast.error("The verification link is invalid or expired.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };

  useEffect(() => {
    async function verifyEmail() {
      if (query.get("token_hash") && query.get("type")) {
        await confirm({
          tokenHash: query.get("token_hash") as string,
          type: query.get("type") as EmailOtpType,
          next: query.get("next") || "/",
        });
      }
    }
    verifyEmail();
  }, []);

  return (
    <>
      <div className="flex min-h-[88vh] items-center justify-center">
        <p className="flex items-center space-x-2">
          <LoaderCircle className="h-4 w-4 animate-spin" />
          <span>
            {query.get("type") === "signup"
              ? "Verifying your email address..."
              : "Please wait..."}
          </span>
        </p>
      </div>
    </>
  );
};

export default Confirm;
